<template>
  <div class="wrapper">
    <div class="main visual-2 abt-hospital hosp-profile">
      <Header :backRoute="'/hospital-settings'" />

      <div class="settings-page">

        <!-- Basic Info -->
        <div class="settings-section">
          <h4 class="section-title">
            <i class="fa-solid fa-hospital section-icon"></i> Basic Information
          </h4>
          <div class="section-grid">
            <div class="form-group">
              <label>Provider Name</label>
              <div class="input-group">
                <i class="fa-solid fa-hospital input-icon"></i>
                <input v-model="hospital.name" type="text" placeholder="Enter Provider Name" />
              </div>
              <p v-if="errors.name" class="error">{{ errors.name }}</p>
            </div>
            <div class="form-group">
              <label>Contact Number</label>
              <div class="input-group">
                <i class="fa-solid fa-phone input-icon"></i>
                <input v-model="hospital.contactNumber" type="text" placeholder="Enter Contact Number" />
              </div>
              <p v-if="errors.contactNumber" class="error">{{ errors.contactNumber }}</p>
            </div>
            <div class="form-group section-grid-full">
              <label>Address</label>
              <div class="input-group">
                <i class="fa-solid fa-location-dot input-icon"></i>
                <input v-model="hospital.address" type="text" placeholder="Enter Address" />
              </div>
              <p v-if="errors.address" class="error">{{ errors.address }}</p>
            </div>
          </div>
        </div>

        <!-- Scheduler Configuration -->
        <div class="settings-section">
          <h4 class="section-title">
            <i class="fa-solid fa-sliders section-icon"></i> Scheduler Configuration
          </h4>
          <div class="section-grid">
            <div class="form-group">
              <label>Logo URL</label>
              <div class="input-group">
                <i class="fa-solid fa-image input-icon"></i>
                <input v-model="hospital.schedulerConfig.logo" type="text" placeholder="Enter Logo URL" />
              </div>
            </div>
            <div class="form-group">
              <label>Email</label>
              <div class="input-group">
                <i class="fa-solid fa-envelope input-icon"></i>
                <input v-model="hospital.schedulerConfig.email" type="email" placeholder="Enter Email" />
              </div>
            </div>
            <div class="form-group">
              <label>Email From Name</label>
              <div class="input-group">
                <i class="fa-solid fa-user-pen input-icon"></i>
                <input v-model="hospital.schedulerConfig.emailFrom" type="text" placeholder="Enter Sender Name" />
              </div>
            </div>
          </div>
          <div class="toggle-list">
            <div class="toggle-row">
              <div class="toggle-info">
                <span class="toggle-name">Captcha</span>
                <span class="toggle-desc">Require captcha verification on the scheduler</span>
              </div>
              <label class="toggle-switch">
                <input type="checkbox" v-model="hospital.schedulerConfig.captcha" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-status" :class="hospital.schedulerConfig.captcha ? 'on' : 'off'">
                {{ hospital.schedulerConfig.captcha ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
            <div class="toggle-row">
              <div class="toggle-info">
                <span class="toggle-name">Signup Button</span>
                <span class="toggle-desc">Show a signup button on the scheduler page</span>
              </div>
              <label class="toggle-switch">
                <input type="checkbox" v-model="hospital.schedulerConfig.signupButton" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-status" :class="hospital.schedulerConfig.signupButton ? 'on' : 'off'">
                {{ hospital.schedulerConfig.signupButton ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Appointment Settings -->
        <div class="settings-section">
          <h4 class="section-title">
            <i class="fa-solid fa-calendar-check section-icon"></i> Appointment Settings
          </h4>
          <div class="toggle-list">
            <div class="toggle-row">
              <div class="toggle-info">
                <span class="toggle-name">Auto Approve</span>
                <span class="toggle-desc">Automatically approve incoming appointments without manual review</span>
              </div>
              <label class="toggle-switch">
                <input type="checkbox" v-model="hospital.autoApprove" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-status" :class="hospital.autoApprove ? 'on' : 'off'">
                {{ hospital.autoApprove ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
            <div class="toggle-row">
              <div class="toggle-info">
                <span class="toggle-name">Same Day Appointments</span>
                <span class="toggle-desc">Allow patients to book appointments for the same day</span>
              </div>
              <label class="toggle-switch">
                <input type="checkbox" v-model="hospital.sameDayAppointments" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-status" :class="hospital.sameDayAppointments ? 'on' : 'off'">
                {{ hospital.sameDayAppointments ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
          </div>
        </div>

        <!-- System Settings -->
        <div class="settings-section">
          <h4 class="section-title">
            <i class="fa-solid fa-gears section-icon"></i> System Settings
          </h4>
          <div class="section-grid">
            <div class="form-group">
              <label>Hospital Key</label>
              <div class="input-group">
                <i class="fa-solid fa-key input-icon"></i>
                <input v-model="hospital.hospitalKey" type="text" placeholder="Enter Hospital Key" />
              </div>
            </div>
          </div>
          <div class="toggle-list">
            <div class="toggle-row">
              <div class="toggle-info">
                <span class="toggle-name">FHIR Enabled</span>
                <span class="toggle-desc">Enable FHIR interoperability for health data exchange</span>
              </div>
              <label class="toggle-switch">
                <input type="checkbox" v-model="hospital.fhirEnabled" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-status" :class="hospital.fhirEnabled ? 'on' : 'off'">
                {{ hospital.fhirEnabled ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
          </div>
        </div>

        <div class="sv-btn">
          <button class="add-new-button" @click="updateHospitalProfile">
            Save Changes
          </button>
        </div>

      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "../layout/Header.vue";
import { HospitalsService } from "@/services/hospitals.service";

export default {
  components: {
    FooterView,
    Header,
  },
  name: "HospitalProfile",
  data() {
    const currentUser = this.$store?.state?.user?.currentUser;
    const profile = currentUser?.profile || {};
    return {
      hospital: {
        ...profile,
        schedulerConfig: {
          logo: "",
          email: "",
          emailFrom: "",
          captcha: false,
          signupButton: false,
          ...(profile.schedulerConfig || {}),
        },
        autoApprove: profile.autoApprove ?? false,
        sameDayAppointments: profile.sameDayAppointments ?? false,
        fhirEnabled: profile.fhirEnabled ?? false,
        hospitalKey: profile.hospitalKey || "",
      },
      user: { ...currentUser },
      errors: {},
    };
  },
  computed: {
    hospitalImage() {
      const storedHospitalId = localStorage.getItem("hospitalId");
      if (storedHospitalId === "68d68a07d3f9b7819cd05e80" || this.hospital?.id === "68d68a07d3f9b7819cd05e80") {
        return require("@/assets/img/494204040_1434613714551416_3095586470864192143_n.jpg");
      }
      return this.hospital?.photo || require("@/assets/img/hospital-img.png");
    },
  },
  methods: {
    async updateHospitalProfile() {
      try {
        const payload = {
          name: this.hospital.name,
          contactNumber: this.hospital.contactNumber,
          address: this.hospital.address,
          schedulerConfig: {
            logo: this.hospital.schedulerConfig.logo,
            email: this.hospital.schedulerConfig.email,
            emailFrom: this.hospital.schedulerConfig.emailFrom,
            captcha: this.hospital.schedulerConfig.captcha,
            signupButton: this.hospital.schedulerConfig.signupButton,
          },
          autoApprove: this.hospital.autoApprove,
          sameDayAppointments: this.hospital.sameDayAppointments,
          fhirEnabled: this.hospital.fhirEnabled,
          hospitalKey: this.hospital.hospitalKey,
        };

        await HospitalsService.update(this.hospital.id, payload);

        this.$store.commit("toast/NEW", {
          type: "success",
          message: "Provider settings updated successfully",
        });

        setTimeout(() => {
          window.location.href = "/hospital-settings";
        }, 800);
      } catch (error) {
        console.error("Error updating provider settings", error);

        this.$store.commit("toast/NEW", {
          type: "error",
          message: "Failed to update provider settings",
        });
      }
    },
  },
};
</script>

<style scoped>
/* Override .main height: 100vh so background stretches with content */
.hosp-profile {
  height: auto !important;
  min-height: 100vh;
  background-attachment: fixed !important;
  background-position: center !important;
}

/* Page container */
.settings-page {
  max-width: 1000px;
  margin: 0 auto;
  padding: 50px 24px 80px;
}

/* Section cards */
.settings-section {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
  margin-bottom: 24px;
  padding: 28px 30px;
}

.section-title {
  color: #0144a6;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Section title icons — plain, no background */
.section-icon {
  font-size: 17px;
  color: #3c78f9;
}

/* Field grid */
.section-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 0 28px;
}

.section-grid-full {
  grid-column: 1 / -1;
}

/* Form fields */
.form-group {
  margin-bottom: 22px;
}

.form-group label {
  display: block;
  font-weight: 500;
  font-size: 15px;
  color: #374151;
  margin-bottom: 8px;
}

.input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
}

.input-group input {
  flex: 1;
  padding: 14px 14px;
  border: 1px solid #e2e8f0;
  border-left: none;
  border-radius: 0 8px 8px 0;
  font-size: 15px;
  color: #1e293b;
  outline: none;
  transition: border-color 0.2s;
}

.input-group input:focus {
  border-color: #3c78f9;
}

/* Input prefix icons */
.input-icon {
  font-size: 15px;
  background-color: #3c78f9;
  color: #fff;
  padding: 0 14px;
  border-radius: 8px 0 0 8px;
  width: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error {
  color: #ef4444;
  font-size: 13px;
  margin-top: 4px;
}

/* Toggle list */
.toggle-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.toggle-row {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 10px;
  padding: 14px 18px;
}

.toggle-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.toggle-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.toggle-desc {
  font-size: 13px;
  color: #94a3b8;
}

.toggle-status {
  font-size: 13px;
  font-weight: 600;
  min-width: 58px;
  text-align: right;
}

.toggle-status.on  { color: #22c55e; }
.toggle-status.off { color: #94a3b8; }

/* Toggle switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 27px;
  cursor: pointer;
  flex-shrink: 0;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  inset: 0;
  background-color: #cbd5e1;
  border-radius: 27px;
  transition: 0.3s;
}

.toggle-slider::before {
  content: "";
  position: absolute;
  height: 19px;
  width: 19px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.3s;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #3c78f9;
}

.toggle-switch input:checked + .toggle-slider::before {
  transform: translateX(23px);
}

/* Save button */
.sv-btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.sv-btn button {
  margin: 0;
  padding: 14px 40px;
}
</style>
